import { createGlobalStyle, css } from 'styled-components';

export const HelpAnnotationsDebugStyle = createGlobalStyle<{
  helpAnnotations: string[];
}>`
${({ helpAnnotations }) =>
  helpAnnotations.length
    ? css`
        [data-annotation]:not(
            ${helpAnnotations
              .map((annotation) => `[data-annotation="${annotation}"]`)
              .join(',')}
          ) {
          display: none !important;
        }
      `
    : css`
        [data-annotation] {
          display: none !important;
        }
      `}
`;
